import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState'

export default function RbsReducer(state = initialState.rbs, action: any) {
  switch (action.type) {
    case types.SAVE_RBS_SUCCESS:
      return action.rbs;
    default:
      return state;
  }
}
